const indiaBase = 36000;
const southAsiaBase = 200;
const globalBase = 400;

export const PRICING_DATA = {
  regions: ["India", "South Asia", "Global"],
  plans: [
    {
      name: "Single User",
      iconKey: "briefcase",
      indiaPrice: indiaBase,
      southAsiaPrice: southAsiaBase,
      globalPrice: globalBase,
      discount: 0.2,
      features: [
        "1 User Account",
        "Basic Billing",
        "Basic View Report",
        "Perfect for individuals needing a simple solution with essential features.",
      ],
    },
    {
      name: "Multi User",
      iconKey: "crown",
      indiaPrice: indiaBase * 3,
      southAsiaPrice: southAsiaBase * 3,
      globalPrice: globalBase * 3,
      features: [
        "Unlimited Users",
        "Full Analytics",
        "Dedicated Manager",
        "Custom Integrations",
        "Fast Billing with Multiple POS Options",
        "Includes all features of other plans",
      ],
      popular: true,
    },
    {
      name: "Dual User",
      iconKey: "users",
      indiaPrice: indiaBase * 1.75,
      southAsiaPrice: southAsiaBase * 1.75,
      globalPrice: globalBase * 1.75,
      features: [
        "2 User Accounts",
        "Advanced Reporting",
        "Priority Support",
        "Ideal for small teams that require collaboration and additional features.",
      ],
    },
  ],
};

export const RENTAL_PRICING = {
  "Single User": { price: 3000, features: ["1 User Account", "Monthly Billing", "Basic Support"] },
  "Dual User": { price: 6000, features: ["2 User Accounts", "Monthly Billing", "Priority Support"] },
  "Multi User": { price: 9000, features: ["Unlimited Users", "Monthly Billing", "Dedicated Manager"] },
};

export function calculateGST(price) {
  return price * 0.18;
}

export function getRegionPrice(plan, region) {
  if (region === "India") return plan.indiaPrice;
  if (region === "South Asia") return plan.southAsiaPrice;
  return plan.globalPrice;
}

export function formatPriceForRegion(price, region) {
  return region === "India" ? `Rs ${price.toLocaleString()}` : `$${price}`;
}

export function getRentalPrice(planName, months = 1) {
  return RENTAL_PRICING[planName].price * months;
}
